import React from 'react';
import { Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { useI18nContext } from '@procore/core-react';
import {
  CityStateCountry,
  prettyPrintCityStateCountry,
} from '../../services/geo-info';

export type TradesTitleProps = {
  text: string;
  appendLocation: boolean;
  component: React.ElementType;
  variant: Variant | 'inherit';
};

export default function BrowseByTradeTitle({
  title,
  location,
}: {
  title?: TradesTitleProps;
  location?: CityStateCountry;
}) {
  const I18n = useI18nContext();
  return !title ? (
    <Typography component="h2" variant="h2">
      {!location?.city && !location?.state && !location?.country
        ? I18n.t('components.browse_by_trade.popular_trades')
        : I18n.t('components.browse_by_trade.popular_trades_in_location', {
            location:
              location.city ||
              location.state?.name ||
              location.country?.preferredName ||
              location.country?.name,
          })}
    </Typography>
  ) : (
    <Typography component={title.component} variant={title.variant}>
      {title.text}
      {title.appendLocation &&
        location &&
        ` in ${prettyPrintCityStateCountry(location)}`}
    </Typography>
  );
}
